module.exports = __webpack_public_path__ + "static/media/capa-light-mobile.bdaff418.png";